/**
 * OIDC Configuration for Omni-Tek SSO (Authentik)
 */

import { getAuthToken } from '../services/api.service';

// Environment variables - loaded from Vite
// Support both 'oidc' and 'entra' as SSO modes
const AUTH_MODE_VALUE = import.meta.env.VITE_AUTH_MODE || 'local';
const OIDC_ENABLED = AUTH_MODE_VALUE === 'oidc' || AUTH_MODE_VALUE === 'entra';
const API_URL = import.meta.env.VITE_API_URL || '';

/**
 * Check if OIDC authentication is enabled
 */
export const isOidcEnabled = (): boolean => {
  return OIDC_ENABLED;
};

/**
 * Get the OIDC login URL
 */
export const getOidcLoginUrl = (): string => {
  return `${API_URL}/auth/oidc/login`;
};

/**
 * Get the OIDC logout URL for Single Logout (SLO)
 * This logs out of Authentik and all connected applications
 * Includes the current auth token so backend can include id_token_hint
 */
export const getOidcLogoutUrl = (): string => {
  const token = getAuthToken();
  const baseUrl = `${API_URL}/auth/oidc/logout`;
  
  // If we have a token, add it as query param so backend can extract user ID
  // and include id_token_hint in the Authentik logout request
  if (token) {
    return `${baseUrl}?token=${encodeURIComponent(token)}`;
  }
  
  return baseUrl;
};

/**
 * Auth mode - 'local' for development, 'oidc'/'entra' for production SSO
 */
export const AUTH_MODE = AUTH_MODE_VALUE;
